


























import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

import NavbarWalletSessionConnectedButton from '@/components/navbar/NavbarWalletSessionConnectedButton.vue'
import NavbarWalletSessionConnectedDropdown from '@/components/navbar/NavbarWalletSessionConnectedDropdown.vue'
import {WalletSessionSummary} from '@/model/wallets/types/WalletSessionSummary'
import {
  TWalletNetwork,
  WALLET_NETWORKS,
} from '@/model/wallets/types/WalletNetwork'
import {siteNetwork} from '@/helpers/NetworkModeRegistry'

@Component({
  components: {
    NavbarWalletSessionConnectedButton,
    NavbarWalletSessionConnectedDropdown,
  },
})
export default class NavbarWalletSessionConnected extends Vue {
  @Prop({type: Array, required: true}) sessions!: WalletSessionSummary[]

  dropdownSessionIsOpen = false

  /** Network the panel is about; starts on the one the page works with. */
  networkSelection: TWalletNetwork = siteNetwork()

  mounted() {
    document.body.addEventListener('click', this.clickOutsideEvent)
  }

  beforeDestroy() {
    document.body.removeEventListener('click', this.clickOutsideEvent)
  }

  /**
   * The panel is a peek at the sessions, not a place to stay: any click that
   * lands elsewhere on the page puts it away.
   */
  clickOutsideEvent(event: MouseEvent) {
    if (!this.dropdownSessionIsOpen) return

    const area = this.$refs.sessionArea as HTMLDivElement | undefined

    if (!area || !area.contains(event.target as Node)) {
      this.dropdownSessionIsOpen = false
    }
  }

  /** A wallet just came in — the panel has served its purpose. */
  @Watch('connectedCount')
  onConnectedCountChange(current: number, previous: number) {
    if (current > previous) {
      this.dropdownSessionIsOpen = false
    }
  }

  get connectedCount(): number {
    return this.sessions.filter(session => session.address).length
  }

  /** Networks a session exists on, mainnet first. */
  get networks(): TWalletNetwork[] {
    return WALLET_NETWORKS.filter(network =>
      this.sessions.some(session => session.network === network)
    )
  }

  /** Nothing to pick while the whole site runs on a single network. */
  get hasNetworkChoice(): boolean {
    return this.networks.length > 1
  }

  /** Clamped: the CMS may drop the network the user had picked. */
  get selectedNetwork(): TWalletNetwork {
    return this.networks.includes(this.networkSelection)
      ? this.networkSelection
      : this.networks[0]
  }

  /**
   * One row per implementation — the button has always shown N3 and Neo X, and
   * the network toggle is what moves between sessions. An implementation that
   * does not run on the selected network keeps the only one it has: Neo X
   * exists for the bridge alone, so it follows the bridge network.
   */
  get visibleSessions(): WalletSessionSummary[] {
    const rows: WalletSessionSummary[] = []

    for (const walletImplementation of ['n3', 'neoX'] as const) {
      const sessions = this.sessions.filter(
        session => session.walletImplementation === walletImplementation
      )
      const session =
        sessions.find(item => item.network === this.selectedNetwork) ??
        sessions[0]

      if (session) rows.push(session)
    }

    return rows
  }

  toggleModalSession() {
    this.dropdownSessionIsOpen = !this.dropdownSessionIsOpen
  }
}
